import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { db, auth } from "../firebase/firebaseConfig";
import { motion, AnimatePresence } from "framer-motion";
import { collection, getDocs, query, where, addDoc, updateDoc, doc } from "firebase/firestore";

// Ensure your actual API key is placed here
const GEMINI_API_KEY = "AIzaSyDVdmf_fS1d5yrSPdvJEMrxXUiRI34gpOQ";

function BookSlot() {
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [topic, setTopic] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTopic, setShowTopic] = useState(false);

  const generateTopic = async () => {
    try {
      const res = await fetch(
        `https://generativelanguage.googleapis.com/v1/models/gemini-1.5-flash:generateContent?key=${GEMINI_API_KEY}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            contents: [{ 
              parts: [{ 
                text: `Act as a Technical HR Recruiter for a top tech company. 
                Generate one unique Group Discussion (GD) topic frequently asked in engineering campus placements or corporate interviews.
                The topic should be related to:
                1. Industry Trends (Fintech, EdTech, automation).
                2. Ethical dilemmas in Engineering.
                3. Modern Corporate Culture vs Student Life.
                4. Impact of technology on society.
                Return ONLY the topic title as a single sentence. No intro, no quotes.
                Random Seed: ${Math.random().toString(36)}` 
              }] 
            }],
            generationConfig: {
              temperature: 0.9, 
              topP: 1,
              maxOutputTokens: 60
            }
          })
        }
      );
      
      const data = await res.json();
      const aiTopic = data?.candidates?.[0]?.content?.parts?.[0]?.text?.trim();

      if (!aiTopic) throw new Error("API Limit or Error");

      return aiTopic.replace(/^["']|["']$|\.$/g, ''); 
    } catch (err) {
      // Professional placement-related fallbacks
      const placementFallbacks = [
        "Work from Home vs Office: Future of Tech Industry",
        "Data Privacy vs Consumer Convenience in Apps",
        "Can AI replace Human Creativity in Engineering?",
        "Importance of Soft Skills for Technical Engineers"
      ];
      return placementFallbacks[new Date().getSeconds() % placementFallbacks.length];
    }
  };

  const handleBooking = async () => {
  if (!name || !date || !time) return alert("Please fill all fields!");

  const selectedDate = new Date(date);
  const today = new Date();
  if (selectedDate < new Date(today.toDateString()))
    return alert("❌ Past date!");

  setIsSubmitting(true);

  try {
    // 🔥 CHECK: SAME USER SHOULD NOT BOOK SAME SLOT AGAIN
    const userCheckQuery = query(
      collection(db, "bookings"),
      where("user", "==", auth.currentUser?.email),
      where("date", "==", date),
      where("time", "==", time)
    );

    const userSnap = await getDocs(userCheckQuery);

    if (!userSnap.empty) {
      alert("⚠️ You have already booked this slot!");
      setIsSubmitting(false);
      return;
    }

    // 🔥 GENERATE AI TOPIC (UNCHANGED)
    const aiTopic = await generateTopic();
    setTopic(aiTopic);
    setShowTopic(true);

    // 🔥 SAVE BOOKING (ONLY ADD NEW FIELDS)
    await addDoc(collection(db, "bookings"), {
      name: name.trim(),
      user: auth.currentUser?.email,
      topic: aiTopic,
      date,
      time,

      // ✅ NEW FIELDS (for future grouping)
      slot: time,
      assigned: false,

      status: "Scheduled",
      createdAt: new Date().toISOString(),
    });

    // 🔥 COUNT USERS IN SAME SLOT
    const sameSlotQuery = query(
      collection(db, "bookings"),
      where("date", "==", date),
      where("time", "==", time)
    );

    const sameSlotSnap = await getDocs(sameSlotQuery);
    //
// 🔥 AUTO GROUPING LOGIC (NEW)
//

const unassignedQuery = query(
  collection(db, "bookings"),
  where("date", "==", date),
  where("slot", "==", time),
  where("assigned", "==", false)
);

const unassignedSnap = await getDocs(unassignedQuery);

// 👉 create groups of 4
if (unassignedSnap.size >= 4) {
  const users = [];

  unassignedSnap.forEach((doc) => {
    users.push({ id: doc.id, ...doc.data() });
  });

  // 🔥 take first 4 users
  const group = users.slice(0, 4);

  // 🎯 CREATE GD ROOM
  const roomRef = await addDoc(collection(db, "gd_rooms"), {
    users: group.map((u) => u.user),
    topic: group[0].topic, // same topic
    date,
    slot: time,
    status: "active",
    createdAt: new Date(),
  });

  // 🔁 MARK USERS AS ASSIGNED
  for (const u of group) {
    await updateDoc(doc(db, "bookings", u.id), {
      assigned: true,
      roomId: roomRef.id,
    });
  }

  console.log("🔥 Group created:", roomRef.id);
}

    // 🔥 FRIEND MESSAGE LOGIC (YOUR REQUIREMENT)
    if (sameSlotSnap.size < 4) {
      alert(
        `✅ Booking successful!\n\nYou can add your ${
          4 - sameSlotSnap.size
        } friend(s) to take GD at this time slot.`
      );
    } else {
      alert(
        `🔥 Great! ${sameSlotSnap.size} participants joined.\nGroups will be formed automatically.`
      );
    }

  } catch (err) {
    console.error(err);
    alert("Something went wrong!");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div style={pageLayout}>
      <Sidebar />

      <div style={contentArea}>
        <Topbar />

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          style={container}
        >
          {/* FORM CARD */}
          <motion.div style={card} whileHover={{ boxShadow: "0 0 20px rgba(99, 102, 241, 0.4)" }}>
            <h2 style={headerText}>Mission Control 🚀</h2>
            <p style={subText}>Schedule your next AI-monitored GD session.</p>

            <div style={inputGroup}>
              <label style={labelStyle}>Full Name</label>
              <input
                type="text"
                placeholder="Enter Your Name"
                style={input}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div style={inputGroup}>
              <label style={labelStyle}>Select Date</label>
              <input
                type="date"
                style={input}
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>

            <div style={inputGroup}>
              <label style={labelStyle}>Preferred Slot</label>
              <select
                style={input}
                value={time}
                onChange={(e) => setTime(e.target.value)}
              >
                <option value="">Choose Time...</option>
                <option>10:00 AM</option>
                <option>12:00 PM</option>
                <option>02:00 PM</option>
                <option>04:00 PM</option>
                <option>08:45 PM</option>
              </select>
            </div>

            <motion.button 
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              style={isSubmitting ? disabledButton : button} 
              onClick={handleBooking}
              disabled={isSubmitting}
            >
              {isSubmitting ? "🤖 Summoning AI..." : "Confirm Booking ⚡"}
            </motion.button>

            <AnimatePresence>
              {showTopic && (
                <motion.div 
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  style={topicBox}
                >
                  <p style={{fontSize: '0.8rem', opacity: 0.8}}>AI HAS SPOKEN:</p>
                  <h3 style={{margin: '10px 0'}}>{topic}</h3>
                  <p style={{fontSize: '0.9rem'}}>Go get 'em, {name}! 🏆</p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* PREVIEW PANEL */}
          <div style={previewSection}>
            <h3 style={{marginBottom: '20px', fontSize: '1.2rem', color: '#94a3b8'}}>Live Preview</h3>

            <motion.div 
              animate={name ? { scale: [1, 1.02, 1] } : {}}
              style={previewCard}
            >
              <div style={badge}>UPCOMING SESSION</div>
              <p style={previewName}>👤 {name || "Agent Name"}</p>
              <h2 style={previewTopic}>{topic || "AI assigning topic..."}</h2>
              
              <div style={previewFooter}>
                <span>📅 {date || "YYYY-MM-DD"}</span>
                <span>⏰ {time || "00:00 AM"}</span>
              </div>
            </motion.div>

            <div style={infoBox}>
              <p>💡 Tip: AI monitors clarity, confidence, and turn-taking logic.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

/* 🎨 PREMIUM STYLES - UNCHANGED */

const pageLayout = {
  display: "flex",
  background: "#050505",
  backgroundImage: "radial-gradient(circle at 50% -20%, #1e1b4b, #050505)",
  minHeight: "100vh",
  color: "white",
  fontFamily: "'Inter', sans-serif",
};

const contentArea = {
  flex: 1,
  marginLeft: "250px",
  padding: "40px",
  display: "flex",
  flexDirection: "column",
};

const container = {
  display: "flex",
  gap: "50px",
  justifyContent: "center",
  alignItems: "flex-start",
  marginTop: "60px",
};

const card = {
  background: "rgba(30, 41, 59, 0.7)",
  backdropFilter: "blur(12px)",
  padding: "40px",
  borderRadius: "24px",
  width: "400px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  border: "1px solid rgba(255, 255, 255, 0.1)",
};

const headerText = { margin: 0, fontSize: "1.8rem", fontWeight: "800", color: "#6366f1" };
const subText = { margin: 0, fontSize: "0.9rem", color: "#94a3b8" };

const inputGroup = { display: "flex", flexDirection: "column", gap: "8px" };
const labelStyle = { fontSize: "0.8rem", fontWeight: "600", color: "#6366f1", marginLeft: "5px" };

const input = {
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #334155",
  background: "#0f172a",
  color: "white",
  outline: "none",
  transition: "0.3s",
};

const button = {
  padding: "16px",
  background: "linear-gradient(135deg, #6366f1 0%, #a855f7 100%)",
  color: "white",
  border: "none",
  borderRadius: "14px",
  fontWeight: "bold",
  fontSize: "1rem",
  cursor: "pointer",
  marginTop: "10px",
  boxShadow: "0 10px 15px -3px rgba(99, 102, 241, 0.4)",
};

const disabledButton = {
  ...button,
  opacity: 0.6,
  cursor: "not-allowed",
  background: "#4b5563",
};

const topicBox = {
  marginTop: "25px",
  background: "rgba(34, 197, 94, 0.1)",
  border: "1px solid #22c55e",
  color: "#4ade80",
  padding: "20px",
  borderRadius: "16px",
  textAlign: "center",
};

const previewSection = { width: "350px" };

const previewCard = {
  background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
  padding: "30px",
  borderRadius: "24px",
  border: "1px solid #334155",
  position: "relative",
  overflow: "hidden",
};

const badge = {
  fontSize: '0.6rem',
  background: '#6366f1',
  padding: '4px 10px',
  borderRadius: '50px',
  width: 'fit-content',
  marginBottom: '15px'
};

const previewName = { margin: "0 0 10px 0", fontSize: "0.9rem", color: "#94a3b8" };
const previewTopic = { margin: "0 0 20px 0", fontSize: "1.4rem", fontWeight: "700", lineHeight: "1.2" };
const previewFooter = { display: "flex", justifyContent: "space-between", fontSize: "0.8rem", color: "#6366f1", fontWeight: "bold" };

const infoBox = {
  marginTop: "20px",
  padding: "15px",
  borderRadius: "12px",
  background: "rgba(99, 102, 241, 0.1)",
  color: "#a5b4fc",
  fontSize: "0.8rem",
  textAlign: "center",
};

export default BookSlot;